import React, { FC } from 'react'

import { Navigate } from 'react-router-dom'
import { Document, Page, pdfjs } from 'react-pdf'
import { Routes } from 'common/constants'
import { SCALE, SCREEN } from 'components/pdf-viewer/utils/constants'

import { Loading } from '@interco/inter-ui/components/Loading'
import { Text } from '@interco/inter-ui/components/Text'

import { PdfContainer } from '../styles/pdfViewer.styles'
import { usePdfViewer } from '../hooks/usePdfViewer'

import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

export const PdfViewer: FC<{
  url: string
}> = ({ url }) => {
  const { onDocumentLoadError, onDocumentLoadSuccess, textContent, totalPages } = usePdfViewer()

  if (!url) return <Navigate to={Routes.ERROR} />

  return (
    <PdfContainer>
      <Document
        file={{ url }}
        error={textContent.errorMessage}
        loading={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <Loading width={24} height={24} />
            <Text variant="body-3" as="p" color="typography" style={{ marginTop: '8px' }}>
              {textContent.downloadingMessage}
            </Text>
          </div>
        }
        className="pdf__container"
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
      >
        {Array.from(new Array(totalPages), (_el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={SCREEN.availWidth - 40}
            scale={SCALE}
          />
        ))}
      </Document>
    </PdfContainer>
  )
}
